import React from 'react';
import { toast } from 'react-toastify';

export default function ShareModal({ isOpen, onClose, url }) {
    if (!isOpen) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(url);
        toast.success("Link copied to clipboard!");
    };

    const shareData = {
        title: 'Check out this event!',
        text: 'I am attending this event, join me!',
        url: url
    };

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error(err);
            }
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000
        }} onClick={onClose}>
            <div style={{
                backgroundColor: 'white',
                padding: '24px',
                borderRadius: '12px',
                width: '90%',
                maxWidth: '500px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={{ margin: 0 }}>Share Event</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>&times;</button>
                </div>

                <p style={{ marginBottom: '8px', color: '#6b7280' }}>Share this link with your guests:</p>

                <div style={{ display: 'flex', gap: '8px', marginBottom: '24px' }}>
                    <input
                        type="text"
                        readOnly
                        value={url}
                        style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#f9fafb' }}
                    />
                    <button onClick={handleCopy} style={{ whiteSpace: 'nowrap' }}>Copy Link</button>
                </div>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <a
                        href={`https://wa.me/?text=${encodeURIComponent(shareData.text + ' ' + url)}`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#25D366', fontSize: '24px' }}
                    >
                        <i className="fa-brands fa-whatsapp"></i>
                    </a>
                    <a
                        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareData.text)}&url=${encodeURIComponent(url)}`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#1DA1F2', fontSize: '24px' }}
                    >

                    </a>
                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: '#4267B2', fontSize: '24px' }}
                    >

                    </a>
                    {navigator.share && (
                        <button onClick={handleNativeShare} className="secondary">
                            More...
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
